import React from "react";
import { Stack, Typography } from "@mui/material";
import { qParamKeys, QParamKey } from "./qParamKeys";

/**
 * 動的設問文（QParam）のキーと値を横並びで一覧表示するコンポーネント
 */
const QParamList = ({
  childrenList,
}: {
  childrenList: Partial<Record<QParamKey, React.ReactNode>>;
}) => {
  return Object.entries(qParamKeys).map(([key, value]) => (
    <Stack key={key} direction="row">
      <Typography color="text.secondary" sx={{ width: "200px" }}>
        {value}
      </Typography>
      {childrenList[key as QParamKey]}
    </Stack>
  ));
};
export default QParamList;
